<!-- Splash Screen - Print-only screen for non-authenticated users (Ctrl+P) -->
<div class="page-splash force-background-graphics-on-print">
  <div class="page-splash-header__container">
    <img class="page-splash-header__background" src="assets/images/headerbg.png" alt="" />
    <h1 class="page-splash-header__text">{{ content?.pageheader }}</h1>
  </div>
  
  <div class="page-splash-body__container">
    <div class="page-splash-body__text">
      <p>{{ content?.pagedesc }}</p>
    </div>
    
    <!-- Layered Documents Section -->
    <div class="layered-documents-container">
      <!-- Left side images -->
      <img
        class="background-doc doc-left-1"
        src="assets/images/ReportPage4.png"
        alt="Roth Conversion Report Page"
      />
      <img
        class="background-doc doc-left-2"
        src="assets/images/ReportPage5.png"
        alt="Roth Conversion Report Page"
      />
      
      <!-- Main center image -->
      <img
        class="main-image"
        src="assets/images/RothIRAPage.png"
        alt="Roth IRA Conversion Report"
      />
      
      <!-- Right side images -->
      <img
        class="background-doc doc-right-1"
        src="assets/images/ReportPage1.png"
        alt="Roth Conversion Report Page"
      />
      <img
        class="background-doc doc-right-2"
        src="assets/images/ReportPage3.png"
        alt="Roth Conversion Report Page"
      />
    </div>
    
    <div class="page-splash-body__cta">
      <h2>{{ content?.signinnow }}</h2>
    </div>
  </div>
  
  <div class="pdf-copyright-container">
    <div class="pdf-copyright-text">{{ content?.copyright1 }}</div>
    <div class="pdf-copyright-text">{{ content?.copyright2 }}</div>
  </div>
</div>
